// ONE rule for who is a trainee and who is a licensed deputy (Jill ruled
// 2026-10-07; the database says the same in tr_is_trainee and
// tr_is_licensed_deputy):
//
//   * A licensed Deputy Marine Pilot working the tonnage ladder has
//     deputy_license_level set. A phase (cruise or cargo) never makes them
//     a trainee; licensed deputies can hold a cargo phase.
//   * "Deputy Marine Pilot Trainee" (trainee_category = 'deputy_trainee') is
//     an ENTRY category for a trainee, beside apprentice and marine pilot
//     trainee. No license level.
//
// Until now three different tests were in use (trainee_category ===
// "deputy_pilot", a license level, a license level with no phase) and Ryan
// Seaver fell between them. Every screen goes through here.

export const TRAINEE_CATEGORIES = ["apprentice", "deputy_trainee", "marine_pilot_trainee"];

export const isLicensedDeputy = (p) => !!p?.deputy_license_level;

export const isTrainee = (p) => !!p && TRAINEE_CATEGORIES.includes(p.trainee_category) && !p.deputy_license_level;
